import Application from '../Application'

export interface ServiceConfig {
  app: Application
  // name: string
  [prop: string]: any
}

export default class Service {
  private readonly _app: Application
  // private readonly _name: string
  private readonly _config: ServiceConfig

  constructor(config: ServiceConfig) {
    this._app = config.app
    // this._name = name
    this._config = config
  }

  destroy(): Promise<void> {
    return Promise.resolve()
  }

  get app(): Application {
    return this._app
  }

  // get name(): string {
  //   return this._name
  // }

  get config(): ServiceConfig {
    return this._config
  }
}
